export const firebaseConfig = {
    apiKey: "AIzaSyAWm7tc0iVn57vcv_7t3GZ1pJuvJ6exBiM",
    authDomain: "smartqa-production.firebaseapp.com",
    projectId: "smartqa-production",
    storageBucket: "smartqa-production.appspot.com",
    messagingSenderId: "3881683049",
    appId: "1:3881683049:web:fa29f15c0da1161bfffaf8"
};